module.exports = __webpack_public_path__ + "media/images/client-32-d9d07decbb8514fc7a31047f93d8b350.png";